import { I18nUtils } from '../../../../i18n/I18nUtils';
import { isCCCValid, isEmailValid } from '../../../shared/utils/StringUtils';

export class CompanyFormValidator {

    static validate(values) {
        const {
            name,
            nif,
            phone,
            ccc,
            contactPerson,
            email,
            address,
        } = values;

        const errors = {};
        const emptyFieldError = I18nUtils.tr('TR_CAMPO_OBLIGATORIO');

        if ( !name ) errors.name = emptyFieldError;
        if ( !nif ) errors.nif = emptyFieldError;
        if ( !phone ) errors.phone = emptyFieldError;
        if ( !ccc ) errors.ccc = emptyFieldError;
        if ( !contactPerson ) errors.contactPerson = emptyFieldError;
        if ( !email ) errors.email = emptyFieldError;
        if ( !address ) errors.address = emptyFieldError;

        if ( ccc && !isCCCValid(ccc) ) errors.ccc = I18nUtils.tr('TR_CCC_INVALIDO');
        if ( email && !isEmailValid(email) ) errors.ccc = I18nUtils.tr('TR_EMAIL_INVALIDO');

        return errors;
    };
}



// WEBPACK FOOTER //
// ./src/app/my-company/company/form/CompanyFormValidator.js